import { Tag } from 'lucide-react';

interface PromotionPreviewProps {
  name: string;
  description: string;
}

export function PromotionPreview({ name, description }: PromotionPreviewProps) {
  return (
    <div className="rounded-lg border bg-card p-4 space-y-2">
      <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
        Preview
      </h4>
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Tag className="h-4 w-4 text-primary" />
          <span className="font-semibold text-sm">
            {name || 'Promotion name'}
          </span>
        </div>
        <p className="text-sm text-muted-foreground pl-6">
          {description || 'Provide a short description to explain this promotion'}
        </p>
      </div>
      <div className="border-t pt-2 mt-2">
        <p className="text-xs text-muted-foreground">
          The name and description are shown to employees and customers to explain the promotion.
        </p>
      </div>
    </div>
  );
}
